export const SET_COURSE_LOADING = 'SET_COURSE_LOADING'
export const SET_COURSE = 'SET_COURSE'
export const ADD_COURSE = 'ADD_COURSE'
export const EDIT_COURSE = 'EDIT_COURSE'
export const DELETE_COURSE = 'DELETE_COURSE'
export const TOGGLE_ASSIGN_USERS = 'TOGGLE_ASSIGN_USERS'
